// components/CustomTitleSelect.tsx
import React, { useState } from "react";
import "./customTitleSelect.css";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";

const TITLES = ["Mr", "Ms", "Mrs", "Dr"];

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const CustomTitleSelect: React.FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="custom-title-select">
      <div className="selector" onClick={() => setOpen((prev) => !prev)}>
        {value || "Title"}
        <span className="arrow">{open ? <FaCaretUp /> : <FaCaretDown />}</span>
      </div>
      {open && (
        <ul className="dropdown">
          {TITLES.map((title) => (
            <li
              key={title}
              className={title === value ? "active" : ""}
              onClick={() => {
                onChange(title);
                setOpen(false);
              }}
            >
              {title}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomTitleSelect;
